document.querySelectorAll('.menu-drawer__list-item--flat').forEach((li,i)=>{
  const link = li.querySelector('.menu-drawer__menu-item--mainlist');
  const sub  = li.querySelector(':scope > .menu-drawer__menu--childlist');
  if(!link || !sub) return;

  link.classList.add('has-children');
  link.style.position = 'relative';
  link.style.paddingRight = '18px';

  link.setAttribute('aria-expanded','false');
  const id = sub.id || `submenu-${i+1}`;
  sub.id = id; link.setAttribute('aria-controls', id);

  const setH = ()=> sub.style.setProperty('--submenu-h', sub.scrollHeight+'px');
  setH(); addEventListener('resize', setH);

  link.addEventListener('click', e=>{
    if(link.getAttribute('href')==='#') e.preventDefault();
    const open = link.getAttribute('aria-expanded')==='true';
    link.setAttribute('aria-expanded', String(!open));
    setH();
  });
});

document.addEventListener('mouseover', function (e) {
  const a = e.target.closest('.zc-card__info .zc-info-swatches .swatch--color');
  if (!a) return;

  const info = a.closest('.zc-card__info');
  const card = info?.previousElementSibling?.matches('.zc-card')
    ? info.previousElementSibling
    : info.parentElement.querySelector('.zc-card');

  const hoverImg = card?.querySelector('.zc-card__img--hover');
  if (!hoverImg) return;

  if (!hoverImg.dataset.originalSrc) {
    hoverImg.dataset.originalSrc = hoverImg.getAttribute('src') || '';
    hoverImg.dataset.originalSrcset = hoverImg.getAttribute('srcset') || '';
  }

  const newSrc = a.getAttribute('data-hover-img');
  const newSrcset = a.getAttribute('data-hover-srcset');

  if (newSrc) hoverImg.setAttribute('src', newSrc);
  if (newSrcset) hoverImg.setAttribute('srcset', newSrcset);

  card.classList.add('is-swatch-hover');
});

document.addEventListener('mouseout', function (e) {
  const swatches = e.target.closest('.zc-card__info .zc-info-swatches');
  if (!swatches) return;
  if (swatches.contains(e.relatedTarget)) return;

  const info = swatches.closest('.zc-card__info');
  const card = info?.previousElementSibling?.matches('.zc-card')
    ? info.previousElementSibling
    : info.parentElement.querySelector('.zc-card');

  const hoverImg = card?.querySelector('.zc-card__img--hover');
  if (!hoverImg) return;

  if (hoverImg.dataset.originalSrc) hoverImg.setAttribute('src', hoverImg.dataset.originalSrc);
  if (hoverImg.dataset.originalSrcset) hoverImg.setAttribute('srcset', hoverImg.dataset.originalSrcset);
  
  card.classList.remove('is-swatch-hover');
});

document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll("accordion-custom details").forEach(details => {
    const content = details.querySelector(".details-content");
    if (content && content.textContent.trim() === "" && content.children.length === 0) {
      details.style.display = "none";
    }
  });
});
